/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespRefineMenu_filters = $ReadOnlyArray<{| |}>;
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbRespRefineMenu_filters",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_filters",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_filters",
      "args": null
    }
  ],
  "type": "SearchBrowseFilter"
};

module.exports = fragment;
